import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { delay, finalize } from 'rxjs';
import { ModalConfig } from 'src/app/shared/components/modal/modal-config';
import { RESET_PASSWORD } from 'src/app/util/constantes-mensajes';
import { HelperFunctions } from 'src/app/util/util-functions';
import { AuthService } from '../auth.service';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit {

  emailForm: FormGroup;
  // Variable to set modal information
  public modalConfig: ModalConfig;
  // Variable to show/hide spinner
  isLoading = false;

  constructor(private authService: AuthService, private ngbActiveModal: NgbActiveModal) { }
  ngOnInit(): void {
    this.emailForm = new FormGroup({
      email: new FormControl(null, [Validators.required, Validators.email])
    })

    this.modalConfig = {
      modalTitle: "Restablecer contraseña",
      ...this.modalConfig,
    };
  }

  /**
  * A function that checks if the control is invalid
  * @param {string} name
  * @returns {boolean}
  */
  hasErrors(): boolean {
    return HelperFunctions.controlIsInvalid(this.emailForm.get("email") as FormControl);
  }


  /**
* A function that submit the parameter list
* @returns {none}
*/
  onSubmit(): void {
    if (this.emailForm.valid) {
      this.isLoading = true;
      this.authService.sendEmailResetPassword(this.emailForm.get('email')?.value).pipe(
        delay(500),
        finalize(() => {
          this.isLoading = false;
        }))
        .subscribe({
          next: () => this.ngbActiveModal.close({ message: RESET_PASSWORD, confirmTitle: "Aceptar" }),
          error: (error) => this.ngbActiveModal.close({ message: error, confirmTitle: "Cerrar", isError: true })
        });
    } else {
      this.emailForm.markAllAsTouched();
    }
  }
}
